"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const graphql_tag_1 = __importDefault(require("graphql-tag"));
const ProductImportTaxesFragment_1 = __importDefault(require("../fragments/ProductImportTaxesFragment"));
const ImportTaxQuery = (0, graphql_tag_1.default) `
  query ImportTaxQuery($importTaxRequest: [ImportTaxRequest]) {
    importTax(importTaxRequest: $importTaxRequest) {
      id
      taxes {
        icmsPercentageRate
        importPercentageRate
        iofPercentageRate
        dolarExchangeRate
        totalValueImportTax
        totalValueICMS
        totalValueIOF
        discount
      }
      products {
        code
        productTaxes {
          realValue {
            ...productImportTaxes
          }
          dolarValue {
            ...productImportTaxes
          }
        }
      }
    }
  }
  ${ProductImportTaxesFragment_1.default}
`;
exports.default = ImportTaxQuery;
